import React from 'react'
import { Widget, async, fromJSX, any } from 'widgets-for-react'
import { Updater } from 'widgets-for-react'
import { EventOverviewState, eventOverviewStateUpdaters } from './eventOverviewState'
import { EventOverviewLayout } from './eventOverviewLayout'
import { paginationWidget } from '../pagination/paginationWidget'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'

export const eventOverviewWidget =
  (page: number, department?: string, subDepartment?: string, specialist?: string, centrum?: string, tags?: string[]) =>
  (state: EventOverviewState): Widget<Updater<EventOverviewState>> =>
    any<Updater<EventOverviewState>>([
      async<NewsOrEvent[]>(state.eventItemsState, items =>
        fromJSX(() => (
          <EventOverviewLayout
            index={234234}
            breadcrumbs={[
              { title: 'Spaarne Gasthuis', url: '/' },
              { title: 'Agenda', url: '/agenda' },
            ]}
            items={items}
          />
        ))
      ).map(eventOverviewStateUpdaters.updateEventItemsState),
      paginationWidget(
        page,
        12,
        (newPage: number) =>
          `/agenda?${(department ? [`department=${department}`] : [])
            .concat(subDepartment ? [`subdepartment=${subDepartment}`] : [])
            .concat(specialist ? [`specialist=${specialist}`] : [])
            .concat(centrum ? [`centrum=${centrum}`] : [])
            .concat(tags ? tags.map((tag) => `tags=${tag}`) : [])
            .join('&')}&page=${newPage}`
      )(state.paginationState).map(eventOverviewStateUpdaters.updateEventCountState),
    ])
